module.exports = __webpack_public_path__ + "img/10.8109aa5f.png";